import React, {Fragment} from 'react';
import {Button, Card, Col, Icon, Modal, Row} from "antd";
import {MARGIN_MD, MODAL_WIDTH_LG} from "../../../styles/constants";
import {translate} from "react-i18next";
import CustomEmpty from "../../custom-empty";
import ArtefactExportReport from "../../artefact-export-report";
import { EL_SOURCE_FORMAT_SDMX_EP } from '../constants';

const ELLoadMetadata = ({
                          t,
                          onMetadataSubmit,
                          metadataImportReport,
                          isMetadataImportReportVisible,
                          dsdTriplet,
                          sourceFormat,
                          onMetadataReportHide
                        }) =>

  /* The Load Metadata button creates the metadata: (codelists, concept scheme when needed) and dsd of the created dataflow, 
  producing a report of the result

  It is enabled when
   - in case of EL_SOURCE_FORMAT_SDMX_EP the metadata Import report has not been yet created by the server
   - otherwise when the dsd has not been created: dsdTriplet === null. 
  
   In case of error creating the dsd, the button is disabled (dsdTriplet === -1 indicates an error creating the dsd)
   
   Button Action: 
    EL_SOURCE_FORMAT_SDMX_EP: Calls "ImportDSDFromDataflow" which creates the metadata import report
    and sets the status variables
      isMetadataImportReportVisible: true,
      metadataImportReport: action.response.itemsMessage 

    EL_SOURCE_FORMAT_DB: Sets the variable status loadTableExists: true, indicating the data table exists
    Otherwise: Calls preloadCSV to load the csv/Excel table, which sets the status variables 
      srcTable: action.response,
      loadTableExists: true

    The last actions trigger the useEffect hooks in \load-step\index.jsx and the metadata import report 
    is created by the client

    When the status variable isMetadataImportReportVisible === true, shows a modal containing the result 
    of the load metadata process

   */
  <Fragment>
    <Row type="flex" justify="center" style={{marginBottom: MARGIN_MD}}>
      <Col>
        <Button
          type="primary"
          onClick={onMetadataSubmit}
          disabled={
            (sourceFormat === EL_SOURCE_FORMAT_SDMX_EP && metadataImportReport !== null) ||
            (sourceFormat !== EL_SOURCE_FORMAT_SDMX_EP && dsdTriplet !== null)
          }
        >
          {t('components.easyLoading.steps.load.body.loadMetadata.title')}
        </Button>
      </Col>
    </Row>
    <Modal
      visible={isMetadataImportReportVisible}
      closable={false}
      title={null}
      footer={null}
      width={MODAL_WIDTH_LG}
    >
      <Row type="flex" justify="space-between">
        <Col>
          <Icon
            type="info-circle"
            style={{
              color: "#1890ff",
              fontSize: 22,
              float: "left"
            }}
          />
        </Col>
        <Col>
          <Icon
            type="close"
            style={{
              fontSize: 16,
              cursor: 'pointer'
            }}
            onClick={onMetadataReportHide}
          />
        </Col>
      </Row>
      <Row>
        <Card
          type="inner"
          title={t("components.easyLoading.steps.load.body.loadMetadata.modals.metadataReport.title")}
          style={{
            marginLeft: 38,
            marginTop: 8
          }}
          bodyStyle={{
            maxHeight: 320,
            overflow: 'auto'
          }}
        >
          {(metadataImportReport || []).length > 0
            ? (
              <ArtefactExportReport
                report={metadataImportReport}
              />
            )
            : (
              <CustomEmpty
                text={t("components.easyLoading.steps.load.body.loadMetadata.modals.metadataReport.noMetadataImported")}
              />
            )
          }
        </Card>
      </Row>
      <Row type="flex" justify="end">
        <Col>
          <Button type="primary" onClick={onMetadataReportHide} style={{marginTop: 24}}>
            OK
          </Button>
        </Col>
      </Row>
    </Modal>
  </Fragment>;

export default translate()(ELLoadMetadata);


// WEBPACK FOOTER //
// ./src/components/easy-loading/load-step/LoadMetadata.jsx